// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1nWMd","alertIcon":"ConfirmModal_alertIcon__3Ctu_"};